import styled, { css } from "styled-components";
import Constants from "const/constants";

export const Wrapper = styled.section`
    padding: 15px;
    display: flex;
    align-items: center;
    font-size: 12px;
    color: ${({ theme }) => theme.colors.text1};
    width: 100%;
    background-color: ${(props) => props.theme.colors.uploadBackground};
`;

export const ProgressBar = styled.div<{ status: string; invalid?: boolean }>`
    width: 100%;
    overflow: hidden;
    position: relative;
    margin: 5px 0;
    border-radius: 4px;
    transition: background-color 0.3s ease-out;

    ${({ status, invalid, theme }) => {
        if (status === Constants.uploadStatusTypes.VALIDATING) {
            return `
				background-color: ${theme.colors.waitingSecondary};
			`;
        } else {
            return `
				background-color: ${
                    invalid
                        ? theme.colors.invalidSecondary
                        : theme.colors.pendingSecondary
                };
			`;
        }
    }}

    div {
        height: 4px;
        border-radius: 4px;
        ${({ theme, invalid }) => {
            if (invalid) {
                return `
				background-color: ${theme.colors.primary};
			`;
            } else {
                return `
				background-color: ${theme.colors.pending};
			`;
            }
        }}
        transition: transform .3s ease-out;
        width: 100%;
        transform-origin: left;
    }
`;

export const Info = styled.div`
    flex: 1;
    width: calc(100% - 22px);
`;

export const Footer = styled.footer`
    display: flex;
    justify-content: space-between;

    span {
        text-transform: capitalize;
    }

    i {
        font-size: 16px;
    }
`;

export const CancelButton = styled.button`
    background: 0;
    margin: 0;
    padding: 0;
    border: none;
    background-color: transparent;
    width: 12px;
    height: 12px;
    margin-left: 10px;

    :hover {
        color: black;
    }

    i {
        font-size: 20px;
        width: 12px;
        height: 12px;
        overflow: hidden;

        :before {
            position: relative;
            top: -4px;
            left: -4px;
        }
    }
`;

export const StatusWrapper = styled.div`
    display: flex;
    align-items: center;
    height: 16px;
`;

export const Status = styled.span<{ status: string; invalid?: boolean }>`
    margin-right: 5px;
    ${({ invalid, status }) => {
        if (invalid) {
            return css`
                color: ${({ theme }) => theme.colors.primary};
            `;
        } else if (
            status === Constants.uploadStatusTypes.VALID ||
            status === Constants.uploadStatusTypes.UPLOADED
        ) {
            return css`
                color: ${({ theme }) => theme.colors.pending};
            `;
        }
    }}
`;

export const HeaderTitle = styled.span`
    position: relative;
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding-bottom: 5px;
    font-weight: ${({ theme }) => theme.fontWeightSemiBold};
`;

export const TooltipList = styled.ul`
    text-align: left;
    padding-left: 15px;
    list-style: square;
`;

export const TooltipNote = styled.p`
    text-align: left;
    padding-top: 2px;
`;

export const TooltipNoteLink = styled.a`
    color: #00a6f3 !important;
`;
